import { addDays, addMonths, addWeeks, differenceInDays, differenceInMonths, differenceInWeeks, format, startOfMonth, startOfWeek } from 'date-fns';

export const getDefaultAggregation = (from, to) => {
  if (differenceInDays(to, from) + 1 <= 35) return 'daily';
  if (differenceInWeeks(to, from) + 1 <= 35) return 'weekly';
  if (differenceInMonths(to, from) + 1 <= 35) return 'monthly';
  return 'yearly';
};

const number = value => typeof value === 'number' && Number.isFinite(value);
const requireShape = valid => { if (!valid) throw new Error('Report unavailable'); };

export function revenueReport(data) {
  requireShape(data && number(data.total_revenue) && number(data.total_orders)
    && Array.isArray(data.buckets) && data.buckets.every(bucket => bucket
      && typeof bucket.date === 'string' && number(bucket.revenue) && number(bucket.orderCount)));
  return data;
}

export function sourceReport(data) {
  requireShape(data && Array.isArray(data.sources) && data.sources.every(row => row
    && typeof row.source === 'string' && number(row.count)));
  return data.sources;
}


export function grossSourceReport(data) {
  requireShape(data && Array.isArray(data.sources) && data.sources.every(row => row
    && typeof row.source === 'string' && number(row.gross)));
  return data.sources;
}

// Identical net and gross figures mean "nothing was deducted" or "nothing is
// entered for this source", and the card has to tell the reader which. Each row
// carries its own coverage for that; the money is validated strictly, while
// covered_days is left to the card, which marks a row only on an exact 0 and so
// cannot invent a marker from a malformed payload (TCA-26102605).
export function netSourceReport(data) {
  requireShape(data && Array.isArray(data.sources) && data.sources.every(row => row
    && typeof row.source === 'string'
    && number(row.gross) && number(row.deductions) && number(row.net)));
  return data.sources;
}

export function pipelineDay(data) {
  requireShape(data && typeof data.date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(data.date)
    && number(data.total) && data.stages
    && ['accepted', 'in_design', 'dispatch', 'en_route', 'done'].every(key => number(data.stages[key]))
    && (data.value_cents == null || number(data.value_cents)));
  return data;
}

// Match the producer's business-date bucket identity, not a timestamp. The
// yearly branch deliberately retains the producer's existing sparse output.
export function fillRevenueBuckets(buckets, from, to, aggregation) {
  if (aggregation === 'yearly') return buckets;
  const lookup = new Map(buckets.map(bucket => [bucket.date, bucket]));
  let date = aggregation === 'weekly' ? startOfWeek(from, { weekStartsOn: 0 })
    : aggregation === 'monthly' ? startOfMonth(from) : from;
  const advance = aggregation === 'weekly' ? addWeeks : aggregation === 'monthly' ? addMonths : addDays;
  const filled = [];
  while (date <= to) {
    const key = format(date, aggregation === 'monthly' ? 'yyyy-MM' : 'yyyy-MM-dd');
    filled.push(lookup.get(key) || { date: key, revenue: 0, orderCount: 0 });
    date = advance(date, 1);
  }
  return filled;
}
